const MakeShip = () => {
  return (
    <div className="w-full flex justify-between px-40 items-center border-t border-[#333] py-16">
      <div className="flex flex-col gap-4">
        <h2 className="text-transparent bg-clip-text bg-gradient-to-r from-[#4285F4] to-[#9B72CB] text-[56px]">
          Make Ship Happen
        </h2>
        <h3 className="text-[20px] text-text5">The development platform for the best frontend teams.</h3>
      </div>
      <div className="flex flex-col gap-4">
        <div className="bg-subColor5 border border-subColor4 text-[#0a0a0a] py-3 px-7 rounded-md flex justify-center items-center">Get started now</div>
        <div className="bg-[#0a0a0a] border border-subColor4 text-subColor5 py-3 px-7 rounded-md flex justify-center items-center">Book a Demo</div>
      </div>
    </div>
  );
};

export default MakeShip;
